import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import CountryCodePicker from "../../../components/CountryCodePicker";
import StepNavigationButtons from "../../../components/Reusables/StepControls/StepNavigationButtons";
import FieldLabel from "./FieldLabel";

const AccountStep = ({
  formData,
  errors,
  handleInputChange,
  setFormData,
  visible,
  onToggleVisible,
  visible2,
  onToggleVisible2,
  onProceed,
  loading,
}) => (
  <div>
    <Typography
      variant="h6"
      sx={{
        fontSize: { xs: "22px", sm: "26px" },
        fontWeight: 600,
        color: "var(--app-text)",
        mb: 1,
        fontFamily: "Figtree",
      }}
    >
      Welcome to Spandan One!
    </Typography>
    <Typography
      variant="body1"
      sx={{
        fontSize: "16px",
        fontWeight: 500,
        color: "var(--app-text-muted)",
        mb: 1,
        fontFamily: "Figtree",
      }}
    >
      Welcome aboard! Spandan One makes ECG testing and reporting easy across
      all your clinics and hospitals. Let’s get your account set up!
    </Typography>
    <br />
    <div className="row">
      <div className="col-12">
        <div className="form-group">
          {formData?.phoneNumber && (
            <>
              <FieldLabel required>Mobile Number</FieldLabel>
              <div className="phone-field-row">
                <div className="phone-field-code">
                  <CountryCodePicker
                    value={formData.countryCode}
                    disabled={true}
                    onChange={() => {}}
                  />
                </div>
                <div className="phone-field-number">
                  <input
                    type="text"
                    className={`form-control`}
                    placeholder="Enter Mobile Number"
                    value={formData.phoneNumber}
                    disabled={true}
                  />
                </div>
              </div>
            </>
          )}
          {formData?.virtualId && (
            <>
              <FieldLabel required>User Id</FieldLabel>
              <input
                type="text"
                className={`form-control`}
                placeholder="Enter User Id"
                value={formData.virtualId}
                disabled={true}
              />
            </>
          )}
        </div>
      </div>

      <div className="col-12 col-sm-6">
        <div className="form-group">
          <FieldLabel required>First Name</FieldLabel>
          <input
            type="text"
            onChange={(e) => handleInputChange("first_name", e.target.value)}
            className="form-control"
            value={formData.first_name}
            placeholder="First Name"
          />
          {errors.first_name && (
            <small className="text-danger">{errors.first_name}</small>
          )}
        </div>
      </div>

      <div className="col-12 col-sm-6">
        <div className="form-group">
          <FieldLabel>Last Name</FieldLabel>
          <input
            type="text"
            onChange={(e) => handleInputChange("last_name", e.target.value)}
            className="form-control"
            value={formData.last_name}
            placeholder="Last Name"
          />
        </div>
      </div>

      <div className="col-12">
        <div className="form-group">
          <FieldLabel>Email Address</FieldLabel>
          <input
            type="email"
            onChange={(e) => handleInputChange("email", e.target.value)}
            className="form-control"
            value={formData.email}
            placeholder="Enter Email Address"
          />

          {errors.email && (
            <small className="text-danger">{errors.email}</small>
          )}
        </div>
      </div>

      <div className="col-12">
        <div className="form-group">
          <FieldLabel required>Create Password</FieldLabel>
          <div className="password-input-wrapper">
            <input
              type={visible ? "text" : "password"}
              maxLength={20}
              placeholder="Enter password"
              className="form-control password-input"
              value={formData.password}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  password: e.target.value,
                }))
              }
            />
            <div className="info-icon" onClick={onToggleVisible}>
              {visible ? (
                <Icon icon="mynaui:eye-solid" width="20" height="20" />
              ) : (
                <Icon icon="el:eye-close" width="20" height="20" />
              )}
            </div>
          </div>
          {errors.password ? (
            <small className="text-danger">{errors.password}</small>
          ) : (
            <small style={{ color: "var(--app-text-muted)" }}>
              Password must be at least 10 characters and include 1
              uppercase, 1 lowercase, 1 number, and 1 special character.
            </small>
          )}
        </div>
      </div>

      <div className="col-12">
        <div className="form-group">
          <FieldLabel required>Confirm Password</FieldLabel>
          <div className="password-input-wrapper">
            <input
              type={visible2 ? "text" : "password"}
              placeholder="Confirm password"
              className="form-control password-input"
              value={formData.confirmPassword}
              onChange={(e) =>
                handleInputChange("confirmPassword", e.target.value)
              }
            />
            <div className="info-icon" onClick={onToggleVisible2}>
              {visible2 ? (
                <Icon icon="mynaui:eye-solid" width="20" height="20" />
              ) : (
                <Icon icon="el:eye-close" width="20" height="20" />
              )}
            </div>
          </div>
          {errors.confirmPassword && (
            <small className="text-danger">{errors.confirmPassword}</small>
          )}
        </div>
      </div>
      <StepNavigationButtons
        hideBack
        onProceed={onProceed}
        loading={loading}
      />
    </div>
  </div>
);

AccountStep.propTypes = {
  formData: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  setFormData: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  onToggleVisible: PropTypes.func.isRequired,
  visible2: PropTypes.bool,
  onToggleVisible2: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default AccountStep;
